import { getCurrentInstance as n, defineComponent as t, withDirectives as r, createElementBlock as s, openBlock as i, vShow as a, unref as l, ref as c } from "vue";
import { _ as d } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const p = () => {
  var e;
  const o = (e = n()) == null ? void 0 : e.appContext.config.globalProperties.$isLoading;
  if (o === void 0)
    throw new Error("$isLoading is not defined in globalProperties");
  return {
    $isLoading: o
  };
}, _ = { class: "loader-overlay" }, g = /* @__PURE__ */ t({
  __name: "GlsLoaderComponent",
  setup(o) {
    const { $isLoading: e } = p();
    return (f, m) => r((i(), s("div", _, null, 512)), [
      [a, l(e)]
    ]);
  }
}), v = /* @__PURE__ */ d(g, [["__scopeId", "data-v-86feabdd"]]), h = {
  install(o) {
    o.config.globalProperties.$isLoading = c(!1);
  }
};
export {
  v as GlsLoaderComponent,
  h as glsLoaderPlugin,
  p as useGlsLoadingState
};
